module.exports = __webpack_public_path__ + "files/1c9198585a2b4af5ba393a3ada2034ef.png";